// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingTable_wrapper__2Ey9h"};